import styled, { css } from 'styled-components';

import { mediaMixin, spaceMixin } from '@zillow/constellation';
import { HR } from '@zillow/zrs-comet';

export const StyledHR = styled(HR)`
  && {
    margin-top: ${spaceMixin('sm')};
    margin-bottom: ${spaceMixin('sm')};
  }
`;

export const StyledHidden = styled.div`
  ${(props: { breakpoint: string }) => {
    return mediaMixin(
      props.breakpoint,
      css`
        display: none;
      `,
    );
  }}
`;
